/**
 * ⚠️：三个步骤的公共部分：
 * 1，table数据的部分加载逻辑
 * 2，toast提示逻辑
 * 3，next逻辑
 */
import { statistics } from '@/api/dot/flow';
import { kitLowCheck } from '@/api/qc/check';
import { mapState } from 'vuex';
import { rebuildEditorErrors, filterLowErrorType } from '@/util/dot';
import { SUBMIT_STATUS, STEP } from './const';
import { ERROE_EMBED } from '@/components/rich-text/const';
import { fieldsCheck } from '@/components/rich-text/utils/check';
import { jsonTextToText } from '@/components/rich-text';
import { hasValidChar } from '@/util/string';

const STATISTICS_TYPE = {
  0: 'low_err_submit',
  1: 'term_abs_submit',
  2: 'high_frequency_submit',
};
export default {
  props: ['queryParams', 'flowCount'],
  data() {
    return {
      STEP,
      records: [],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      errorCount: 0,
      loading: false,
      submitStatusEnum: SUBMIT_STATUS,
      staParams: {
        time: new Date().getTime(),
        browser: navigator.userAgent.toLowerCase(),
        url: document.URL,
        scene_name: '智能检查',
      },
      canSubmit: true,
      multiSelection: [],
      fullLoading: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  mounted() {
    this.fetchListData();
  },
  methods: {
    handleSelectionChange(val) {
      this.multiSelection = val;
    },
    // 已编辑未提交的message提示逻辑
    handleFocus() {
      const editedRecords = document.querySelectorAll(
        '.table-wrap .edit-un-submit',
      );

      if (editedRecords.length) {
        this.$message({
          message: '修改内容还未提交哦',
          type: 'warning',
        });
      }
    },
    clearCustomError(json) {
      const copyJson = JSON.parse(JSON.stringify(json));
      return copyJson.map((item) => {
        if (
          item.attributes &&
          item.attributes[ERROE_EMBED.custom_error] !== undefined
        ) {
          delete item.attributes[ERROE_EMBED.custom_error];
        }
        return item;
      });
    },
    handleChange(text, json, row) {
      row.editedText = text;
      row.editedJson = JSON.stringify(this.clearCustomError(json));
    },
    handleBlur(text, json, row) {
      row.editedText = text;
      row.editedJson = JSON.stringify(this.clearCustomError(json));

      kitLowCheck({
        sentId: row.sentId ?? row.id,
        src: row.srcText ?? row.srcTxt,
        tgt: row.editedJson,
        orderId: this.queryParams.id,
      }).then((res) => {
        const usableData = res.data?.data ?? {};
        if (usableData) {
          const lowErrList = filterLowErrorType(usableData.errDtoList);
          row.errors = rebuildEditorErrors(lowErrList);
        } else {
          row.errors = [];
        }
      });
    },
    // 域匹配检查
    sentDigitCheck(row) {
      const peJsonText = JSON.parse(row.editedJson ?? row.qcText);
      const isMatched = fieldsCheck(peJsonText);
      if (!isMatched) {
        this.$message.error(
          '提交失败，译文框的内容中检测存在域没有成对出现、域开闭顺序不对、域交叉等问题',
        );
      }
      return isMatched;
    },
    batchSubmitCheck() {
      return new Promise((resolve, reject) => {
        // 1. 域匹配校验
        const isAllMatched = this.multiSelection?.every((item) => {
          return this.sentDigitCheck(item);
        });
        if (!isAllMatched) {
          reject({ isAllMatched: false });
        }

        // 2. 译文为空校验
        const isAllFilled = this.multiSelection?.every((item) => {
          return hasValidChar(item.editedText);
        });
        if (!isAllFilled) {
          this.$confirm(
            '<h4>存在译文为空的句子</h4><div>请谨慎操作！译文为空的场景一般应用于原文断句异常时，已将此句的译文合并入其他句子中。</div>',
            '译文为空预警',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            },
          )
            .then(() => {
              resolve();
            })
            .catch(() => {
              this.multiSelection.forEach((item) => {
                if (item.editedText?.trim() === '') {
                  item.editedText = item.qcText && jsonTextToText(item.qcText);
                  item.editedJson = item.qcText;
                  item.errors = item.errDtoList
                    ? rebuildEditorErrors(item.errDtoList)
                    : [];
                  item.updateSign++;
                }
                reject({ isAllFilled: false });
              });
            });
        }

        if (isAllFilled && isAllMatched) resolve();
      });
    },
    next(curStep) {
      // 上报
      statistics(
        Object.assign(
          {
            event_type: 'click',
            event_name: STATISTICS_TYPE[curStep],
            ref_url: this.oldPath,
            event_params: {
              order_id: this.queryParams.id,
            },
            u_id: this.userInfo?.staffId,
          },
          this.staParams,
        ),
      );
      this.$emit('next');
    },
    handleCurrentChange() {
      this.fetchListData();
    },
  },
};
